// users#new — signup. Fills the hidden timezone field from the browser.
import { registerPage } from "../first"
import { mountSignupTimezone } from "../signup"

export const UsersNewPage = {
  onDomReady(): void {
    mountSignupTimezone()
  },
}

registerPage("UsersNewPage", UsersNewPage)
